/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TutorHeader_tutor = {|
  +firstname: ?string;
  +lastname: ?string;
  +cellphoneNumber: ?string;
  +aboutMe: ?string;
  +profilePictureUri: ?string;
  +documentsCount: ?number;
  +user: {|
    +email: string;
    +status: string;
    +active: boolean;
    +facebookProfileLink: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TutorHeader_tutor",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "firstname",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "lastname",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "cellphoneNumber",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "aboutMe",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "large",
          "type": "PictureSize"
        }
      ],
      "name": "profilePictureUri",
      "storageKey": "profilePictureUri{\"size\":\"large\"}"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "documentsCount",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "User",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "status",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "active",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "facebookProfileLink",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Tutor"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/__generated__/TutorHeader_tutor.graphql.js